angular.module('NumbersEditor')
    .factory('SearchFactory', [
        '$http', function ($http) {

            var urlBase = '/api/home';
            var searchFactory = {};

           searchFactory.searchGame = function (date) {
                var param = zeroPad(date.getDate(), 2) + "" +
                    zeroPad(date.getMonth() + 1, 2) + "" +
                    date.getFullYear();
                return $http.post(urlBase + '/search/' + param);
            };

            function zeroPad(num, places) {
                var zero = places - num.toString().length + 1;
                return Array(+(zero > 0 && zero)).join("0") + num;
            }

            return searchFactory;
        }
    ]);